module.exports = __webpack_public_path__ + "img/lose_s.c0645748.gif";